import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
const environment = process.env.CONFIG_ENV || 'daily'
let initialized = false

export function init() {
  initialized = false
  // Monitoring is opt-in so demo builds never call an unavailable endpoint.
  if (process.env.SENTRY_ENABLED !== 'true' || !process.env.SENTRY_DSN) {
    return false
  }

  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    environment,
    beforeSend(event, hint) {
      // Ignore API errors caused by data permission checks.
      const error = hint.originalException
      if (error?.message?.match?.(/403@/i)) {
        return
      }
      // Ignore request errors that have already been classified.
      if (error?.message?.match?.(/info@/i)) {
        return
      }
      // filter antd error, detail see https://github.com/ant-design/ant-design/issues/26621
      if (
        event.exception?.values?.[0].value?.match(
          'ResizeObserver loop limit exceeded'
        )
      ) {
        return
      }
      console.log(arguments)
      return event
    }
  })
  initialized = true
  return true
}

export function setUser(user) {
  if (!initialized) return

  Sentry.setUser({ id: user?.id, username: user?.name })
}

export function catchRequestError(response = {}, err) {
  if (initialized) {
    const { status, config = {}, request = {} } = response
    const { responseURL } = request
    const { method } = config
    Sentry.withScope(scope => {
      // Group errors by their request and response contract.
      scope.setFingerprint([method, responseURL, String(status)])
      scope.setLevel('info')
      Sentry.captureException(err)
    })
  }

  const failure = new Error(`info@${err.message}`)
  // Keep the transport status so callers can distinguish access denial from service failure.
  if (Number.isInteger(response.status)) failure.status = response.status
  return Promise.reject(failure)
}
